import { Box } from "@mui/system"
import { makeStyles } from "tss-react/mui"
import { ReceiptNavigation } from "./ReceiptNavigation"
import { ReceiptAndSlipDialogHeader } from "../../../modules/merchant/merchant/components/receiptAndSlip/ReceiptAndSlipDialogHeader"
import { SharePrintButtons } from "./SharePrintButtons"
import { SelectChangeEvent } from "@mui/material"
import { tailwindPalette } from "../../../modules/theme/tailwindPalette"

const useStyles = makeStyles()((theme) => ({
    container: {
        backgroundColor: tailwindPalette.slate[100],
        minHeight: "100vh",
        gap: "3.5rem",
        paddingBottom: "3.5rem",
        justifyContent: "start",
        [theme.breakpoints.down("sm")]: {
            backgroundColor: theme.palette.common.white,
            gap: 0,
        },
        "@media print": {
            backgroundColor: "transparent",
            minHeight: "auto",
            width: "100vw",
            paddingBottom: 0,
        },
    },
    slideContainer: {
        flex: 1,
        display: "flex",
        justifyContent: "center",
    },
    slide: {
        width: "80%",
        "@media print": {
            width: "100%",
            display: "block",
        },
    },
    header: {
        display: "grid",
        gridTemplateColumns: "minmax(0,1fr) auto minmax(0,1fr)", // L | C | R
        justifyContent: "space-between",
        alignItems: "center",
        padding: "1.5rem",
        position: "sticky",
        top: 0,
        backgroundColor: "white",
        boxShadow: "0px 2px 6px 0px #00000014",
        "@media print": {
            display: "none",
        },
        [theme.breakpoints.down("sm")]: {
            gridTemplateColumns: "minmax(0,1fr) minmax(0,1fr)",
            padding: "0 1.5rem",
            zIndex: 1,
            boxShadow: "0px 3px 1px -2px #00000033,  0px 2px 2px 0px #00000024, 0px 1px 5px 0px #0000001F",
        },
    },
    carouselContainer: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        gap: "1rem",
    },
    carouselText: {
        fontSize: "1rem",
    },
    logo: {
        width: "auto",
    },
    logoLink: {
        display: "flex",
        alignItems: "center",
        [theme.breakpoints.up("sm")]: {
            display: "none",
        },
    },
    actionButtons: {
        justifySelf: "end",
    },
    navigationContainer: {
        [theme.breakpoints.down("sm")]: {
            display: "none",
        },
    },
}))

type ReceiptHeder = {
    activeOrder: any
    handleOrderChange: (event: SelectChangeEvent<string>) => void
    uid?: string
    orderIdsLength?: number
    isSelectMode: boolean
    orderDetails: any
    orders: any
    onClose: () => void
    isAuthenticated: boolean
    goToPreviousOrder: () => void
    goToNextOrder: () => void
    currentMeetingIndex: number
    ordersLength: number
    variant: "slip" | "receipt" | "pos"
}

export const ReceiptHeder = ({
    activeOrder,
    handleOrderChange,
    uid,
    orderIdsLength,
    isSelectMode,
    orderDetails,
    orders = [],
    onClose,
    isAuthenticated,
    goToPreviousOrder,
    goToNextOrder,
    currentMeetingIndex,
    ordersLength,
    variant,
}: ReceiptHeder) => {
    const { classes } = useStyles()

    return (
        <Box className={classes.header}>
            <ReceiptAndSlipDialogHeader
                handleOrderChange={handleOrderChange}
                id={Number(activeOrder?.id)}
                uid={uid}
                orderIdsLength={orderIdsLength}
                isAuthenticated={isAuthenticated}
                isSelectMode={isSelectMode}
                orders={orders}
                orderDetails={orderDetails}
                variant={variant}
            />

            <ReceiptNavigation
                isAuthenticated={isAuthenticated}
                isSelectMode={isSelectMode}
                goToPreviousOrder={goToPreviousOrder}
                goToNextOrder={goToNextOrder}
                ordersLength={ordersLength}
                currentMeetingIndex={currentMeetingIndex}
            />

            <Box className={classes.actionButtons}>
                <SharePrintButtons onClose={onClose} hasShare={false} hasClose={true} copyUrl="" />
            </Box>
        </Box>
    )
}
